module.exports = __webpack_public_path__ + "img/loader.3f259006.gif";